<template>
  <v-dialog
    v-model="localValue"
    content-class="ordenes-dialog-wrapper"
    max-width="1450"
    width="96%"
  >
    <v-card class="ordenes-dialog">

      <!-- =====================================================
           HEADER
           ===================================================== -->
      <div class="ordenes-header">
        <div class="ordenes-header-left">
          <button
            type="button"
            class="ordenes-close"
            @click="localValue = false"
            aria-label="Cerrar"
          >
            <v-icon>mdi-close</v-icon>
          </button>

          <div class="ordenes-header-icon">
            <v-icon>mdi-receipt-text-outline</v-icon>
          </div>

          <div class="ordenes-header-title">
            <span class="ordenes-title">
              {{ title }}
            </span>

            <span class="ordenes-subtitle">
              Órdenes
            </span>
          </div>
        </div>

        <div class="ordenes-header-right">
          <div class="ordenes-counter">
            <v-icon small>mdi-format-list-bulleted</v-icon>
            <span>{{ ordenes_carousel.length }}</span>
          </div>

          <button
            type="button"
            class="ordenes-close"
            @click="localValue = false"
            aria-label="Cerrar"
          >
            <v-icon>mdi-close</v-icon>
          </button>
        </div>
      </div>

      <!-- =====================================================
           CONTENIDO
           ===================================================== -->
      <div class="ordenes-content">

        <div
          v-if="!ordenes_carousel.length"
          class="ordenes-empty"
        >
          <div class="ordenes-empty-icon">
            <v-icon>mdi-receipt-text-remove-outline</v-icon>
          </div>

          <div class="ordenes-empty-title">
            No hay órdenes
          </div>

          <div class="ordenes-empty-text">
            Actualmente no hay órdenes disponibles para mostrar.
          </div>
        </div>

        <div
          v-else
          class="ordenes-grid"
        >
          <div
            v-for="orden in ordenes_carousel"
            :key="orden.intPOSEnc"
            class="orden-grid-item"
          >
            <v-card
              class="orden-card"
              :class="{
                'orden-card-mesa': orden.intPOSTipoServicio == 1,
                'orden-card-domicilio': orden.intPOSTipoServicio == 2,
                'orden-card-llevar': orden.intPOSTipoServicio == 3
              }"
              :img="getImage(orden)"
              flat
              @click="seleccionar(orden)"
            >

              <!-- overlay -->
              <div class="orden-card-overlay"></div>

              <!-- =================================================
                   CARD HEADER
                   ================================================= -->
              <div class="orden-card-header">

                <div class="orden-card-number">
                  <span class="orden-number-label">
                    ORDEN
                  </span>

                  <span class="orden-number">
                    {{ orden.intOrden }}
                  </span>
                </div>

                <div
                  v-if="tienePendientes(orden)"
                  class="orden-pending"
                  title="Tiene productos pendientes"
                >
                  <v-icon small>
                    mdi-bell-ring
                  </v-icon>
                </div>
              </div>

              <!-- =================================================
                   CARD CONTENT
                   ================================================= -->
              <div class="orden-card-content">

                <!-- tipo -->
                <div class="orden-service">
                  <div class="orden-service-icon">
                    <v-icon small>
                      {{
                        orden.intPOSTipoServicio == 1
                          ? 'mdi-table-chair'
                          : orden.intPOSTipoServicio == 2
                            ? 'mdi-moped'
                            : 'mdi-shopping-outline'
                      }}
                    </v-icon>
                  </div>

                  <span>
                    {{ getLabel(orden.intPOSTipoServicio) }}
                  </span>
                </div>

                <!-- estatus -->
                <div class="orden-status">
                  {{ getEstatus(orden.intEstatus) }}
                </div>

                <!-- MESA -->
                <div
                  v-if="orden.intPOSTipoServicio == 1"
                  class="orden-info-row orden-highlight"
                >
                  <v-icon small>
                    mdi-table-furniture
                  </v-icon>

                  <span>
                    {{ orden.strMesa }}
                  </span>
                </div>

                <!-- DOMICILIO -->
                <template v-if="orden.intPOSTipoServicio == 2">

                  <div class="orden-info-row">
                    <v-icon small>
                      mdi-account-outline
                    </v-icon>

                    <span>
                      {{ orden.cliente.strNombre }}
                      {{ orden.cliente.strTelefono }}
                    </span>
                  </div>

                  <div class="orden-info-row">
                    <v-icon small>
                      mdi-map-marker-outline
                    </v-icon>

                    <span>
                      {{ orden.cliente.strDireccion }}
                      {{ orden.cliente.strColonia }}
                    </span>
                  </div>

                </template>

                <!-- LLEVAR -->
                <div
                  v-if="orden.intPOSTipoServicio == 3"
                  class="orden-info-row orden-highlight"
                >
                  <v-icon small>
                    mdi-shopping-outline
                  </v-icon>

                  <span>
                    {{ orden.strMesa }}
                  </span>
                </div>

                <!-- MESERO -->
                <div
                  v-if="orden.intPOSTipoServicio == 1"
                  class="orden-info-row"
                >
                  <v-icon small>
                    mdi-account-tie-outline
                  </v-icon>

                  <span>
                    {{ getMesero(orden) }}
                  </span>
                </div>

                <!-- FECHA -->
                <div class="orden-info-row orden-date">
                  <v-icon small>
                    mdi-clock-outline
                  </v-icon>

                  <span>
                    {{ toDateString(orden.datFecha, 2) }}
                  </span>
                </div>

                <!-- GUIA -->
                <div
                  v-if="title == 'Factura'"
                  class="orden-guia"
                >
                  <span>GUIA</span>
                  <strong>{{ orden.strMesa }}</strong>
                </div>

              </div>

              <!-- =================================================
                   FOOTER
                   ================================================= -->
              <div class="orden-card-footer">

                <span>
                  Ver orden
                </span>

                <v-icon small>
                  mdi-chevron-right
                </v-icon>

              </div>

            </v-card>
          </div>
        </div>

      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { toDateString } from "../js/utilities";

export default {
  props: {
    ordenes: {
      type: Array,
      default: () => [],
    },

    meseros: {
      type: Array,
      default: () => [],
    },

    register: {
      type: Number,
      default: 0,
    },

    value: {
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      localValue: this.value,

      title: this.$config.ordenTitle,

      config_37_activo: this.$config.opciones.find(
        (c) => c.id == 37
      ).activo,
    };
  },

  methods: {
    toDateString: toDateString,

    getLabel(intPOSTipoServicio) {
      if (intPOSTipoServicio == 1) {
        return "MESA";
      } else if (intPOSTipoServicio == 2) {
        if (this.title == "Factura") {
          return "";
        } else {
          return "DOMICILIO";
        }
      } else if (intPOSTipoServicio == 3) {
        return "LLEVAR";
      }
    },

    tienePendientes(orden) {
      const config37 = this.$config.opciones.find(
        (c) => c.id == 37
      );

      if (!config37 || !config37.activo) {
        return false;
      }

      if (!orden.posDet || !orden.posDet.length) {
        return false;
      }

      return orden.posDet.some(
        (det) => det.intPreparado == null
      );
    },

    getColor(orden) {
      if (orden.intPOSTipoServicio == 1) {
        return "primary";
      } else if (orden.intPOSTipoServicio == 2) {
        return "green";
      } else if (orden.intPOSTipoServicio == 3) {
        return "secondary";
      }
    },

    getMesero(orden) {
      const mesero = this.meseros.find(
        (mesero) =>
          mesero.intPOSMesero == orden.intPOSMesero
      );

      if (mesero != null) {
        return (
          mesero.strNombre +
          " " +
          mesero.strApellidoPaterno
        );
      } else {
        return "NO ASIGNADO";
      }
    },

    getImage(orden) {
      if (orden.intPOSTipoServicio == 1) {
        return "/imagenes/table.jpg";
      } else if (
        orden.intPOSTipoServicio == 2 &&
        orden.intEstatus == 3
      ) {
        return "/images/domicilio.jpg";
      } else if (orden.intPOSTipoServicio == 3) {
        return "/imagenes/takeaway.jpg";
      }
    },

    getEstatus(estatus) {
      // conf para dicex
      let config_21 = this.$config.opciones.find(
        (c) => c.id == 21
      );

      if (config_21.valor) {
        if (estatus == 1) return "ALTA";
        else if (estatus == 2) return "PAGADA";
        else if (estatus == 3) return "PAGO PARCIAL";
        else if (estatus == 9) return "CANCELADA";
      } else {
        if (estatus == 1) return "REGISTRADA";
        else if (estatus == 2) return "EN PROCESO";
        else if (estatus == 3) return "TERMINADA";
        else if (estatus == 4) return "PAGADA";
      }
    },

    seleccionar(orden) {
      this.$emit("seleccionar", orden);
    },
  },

  computed: {
    ordenes_carousel() {
      return this.ordenes
        .slice(
          this.ordenes.length - this.minOrdenes,
          this.ordenes.length
        )
        .sort((a, b) =>
          a.intPOSEnc > b.intPOSEnc ? 1 : -1
        );
    },
  },

  watch: {
    localValue(newValue) {
      this.$emit("input", newValue);
    },

    loading(newValue) {
      this.$emit("loading", newValue);
    },

    value(newValue) {
      this.localValue = newValue;
    },
  },
};
</script>

<style scoped>
/* ============================================================
   TPV · ORDENES
   Adaptación visual al nuevo Main.vue
   ============================================================ */

.ordenes-dialog {
  --tpv-primary: #113e75;
  --tpv-primary-hover: #0c2b52;
  --tpv-light: #58789e;
  --tpv-secondary: #b97823;
  --tpv-success: #fe9000;

  --tpv-background: #f4f5f7;
  --tpv-surface: #ffffff;
  --tpv-border: #e2e4e8;
  --tpv-text: #1a1d23;
  --tpv-muted: #6b7280;

  font-family: "Inter", sans-serif;
  background: var(--tpv-background);
  overflow: hidden;
  border-radius: 18px !important;
}

/* ============================================================
   HEADER
   ============================================================ */

.ordenes-header {
  min-height: 68px;
  height: 68px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 20px;

  background: #347ea8;
  color: white;
}

.ordenes-header-left,
.ordenes-header-right {
  display: flex;
  align-items: center;
}

.ordenes-header-left {
  min-width: 0;
}

.ordenes-close {
  width: 36px;
  height: 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 0;
  border-radius: 10px;

  background: rgba(255, 255, 255, 0.08);
  color: white;

  cursor: pointer;

  transition:
    background 0.2s ease,
    transform 0.2s ease;
}

.ordenes-close:hover {
  background: rgba(255, 255, 255, 0.18);
}

.ordenes-close:active {
  transform: scale(0.94);
}

.ordenes-header-icon {
  width: 40px;
  height: 40px;

  margin-left: 12px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 11px;

  background: rgba(255, 255, 255, 0.12);
}

.ordenes-header-icon .v-icon {
  color: white;
  font-size: 22px;
}

.ordenes-header-title {
  display: flex;
  flex-direction: column;

  margin-left: 12px;

  min-width: 0;
}

.ordenes-title {
  font-size: 17px;
  line-height: 21px;
  font-weight: 700;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ordenes-subtitle {
  margin-top: 1px;

  font-size: 11px;
  line-height: 14px;

  font-weight: 500;

  color: rgba(255, 255, 255, 0.72);
}

.ordenes-header-right {
  gap: 10px;
}

.ordenes-counter {
  min-width: 42px;
  height: 32px;

  padding: 0 10px;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 6px;

  border-radius: 9px;

  background: rgba(255, 255, 255, 0.12);

  font-size: 13px;
  font-weight: 700;
}

.ordenes-counter .v-icon {
  color: white;
}

/* ============================================================
   CONTENIDO
   ============================================================ */

.ordenes-content {
  padding: 20px;

  background: var(--tpv-background);

  max-height: calc(100vh - 120px);
  overflow-y: auto;
  overflow-x: hidden;
}

/* ============================================================
   GRID
   ============================================================ */

.ordenes-grid {
  display: grid;

  grid-template-columns: repeat(
    6,
    minmax(0, 1fr)
  );

  gap: 16px;
}

.orden-grid-item {
  min-width: 0;
}

/* ============================================================
   CARD
   ============================================================ */

.orden-card {
  position: relative;

  min-height: 285px;

  display: flex;
  flex-direction: column;

  overflow: hidden;

  border-radius: 16px !important;

  background-color: var(--tpv-primary) !important;

  cursor: pointer;

  box-shadow:
    0 4px 12px rgba(17, 62, 117, 0.10),
    0 1px 3px rgba(0, 0, 0, 0.06);

  transition:
    transform 0.20s ease,
    box-shadow 0.20s ease;
}

.orden-card:hover {
  transform: translateY(-3px);

  box-shadow:
    0 12px 26px rgba(17, 62, 117, 0.18),
    0 3px 8px rgba(0, 0, 0, 0.08);
}

.orden-card:active {
  transform: translateY(-1px) scale(0.99);
}

/* ============================================================
   OVERLAY
   ============================================================ */

.orden-card-overlay {
  position: absolute;
  inset: 0;

  background:
    linear-gradient(
      180deg,
      rgba(17, 62, 117, 0.48) 0%,
      rgba(17, 62, 117, 0.72) 48%,
      rgba(17, 62, 117, 0.94) 100%
    );

  z-index: 0;
}

/* ============================================================
   COLORES POR SERVICIO
   ============================================================ */

.orden-card-mesa {
  background-color: var(--tpv-primary) !important;
}

.orden-card-domicilio {
  background-color: #287c51 !important;
}

.orden-card-llevar {
  background-color: #6c4a8c !important;
}

/* ============================================================
   CARD HEADER
   ============================================================ */

.orden-card-header {
  position: relative;
  z-index: 2;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 15px 15px 8px;
}

.orden-card-number {
  display: flex;
  flex-direction: column;
}

.orden-number-label {
  font-size: 9px;
  line-height: 11px;

  font-weight: 700;
  letter-spacing: 0.9px;

  color: rgba(255, 255, 255, 0.65);
}

.orden-number {
  margin-top: 2px;

  font-size: 22px;
  line-height: 25px;

  font-weight: 800;

  color: white;
}

.orden-pending {
  width: 31px;
  height: 31px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 9px;

  background: rgba(255, 193, 7, 0.18);

  border: 1px solid rgba(255, 230, 120, 0.38);

  animation: ordenPulse 1.8s infinite;
}

.orden-pending .v-icon {
  color: #ffe36b !important;
}

@keyframes ordenPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 227, 107, 0.35);
  }

  70% {
    box-shadow: 0 0 0 7px rgba(255, 227, 107, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(255, 227, 107, 0);
  }
}

/* ============================================================
   CARD CONTENT
   ============================================================ */

.orden-card-content {
  position: relative;
  z-index: 2;

  flex: 1;

  padding: 5px 15px 12px;

  color: white;
}

.orden-service {
  display: flex;
  align-items: center;

  gap: 7px;

  font-size: 11px;
  font-weight: 700;

  letter-spacing: 0.5px;

  color: rgba(255, 255, 255, 0.85);
}

.orden-service-icon {
  width: 26px;
  height: 26px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;

  background: rgba(255, 255, 255, 0.13);
}

.orden-service-icon .v-icon {
  color: white;
}

.orden-status {
  display: inline-flex;

  margin-top: 8px;
  margin-bottom: 10px;

  padding: 5px 9px;

  border-radius: 7px;

  background: rgba(255, 255, 255, 0.14);

  font-size: 9px;
  line-height: 11px;

  font-weight: 800;

  letter-spacing: 0.5px;

  color: white;
}

.orden-info-row {
  min-width: 0;

  display: flex;
  align-items: flex-start;

  gap: 7px;

  margin-top: 7px;

  font-size: 10px;
  line-height: 14px;

  color: rgba(255, 255, 255, 0.84);
}

.orden-info-row .v-icon {
  flex: 0 0 auto;

  margin-top: 0;

  color: rgba(255, 255, 255, 0.72);
}

.orden-info-row span {
  min-width: 0;

  overflow: hidden;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  word-break: break-word;
}

.orden-highlight {
  color: white;
  font-weight: 700;
}

.orden-highlight .v-icon {
  color: white;
}

.orden-date {
  margin-top: 9px;

  padding-top: 8px;

  border-top: 1px solid rgba(255, 255, 255, 0.14);

  font-size: 9px;
}

/* ============================================================
   GUIA
   ============================================================ */

.orden-guia {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-top: 9px;
  padding: 7px 9px;

  border-radius: 8px;

  background: rgba(255, 255, 255, 0.12);

  font-size: 9px;
}

.orden-guia span {
  font-weight: 700;
  color: rgba(255, 255, 255, 0.65);
}

.orden-guia strong {
  color: white;
  font-size: 11px;
}

/* ============================================================
   FOOTER
   ============================================================ */

.orden-card-footer {
  position: relative;
  z-index: 2;

  min-height: 40px;

  padding: 0 15px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  border-top: 1px solid rgba(255, 255, 255, 0.12);

  color: rgba(255, 255, 255, 0.68);

  font-size: 9px;
  font-weight: 600;
}

.orden-card-footer .v-icon {
  color: rgba(255, 255, 255, 0.72);
}

/* ============================================================
   EMPTY
   ============================================================ */

.ordenes-empty {
  min-height: 330px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;

  border: 1px dashed var(--tpv-border);
  border-radius: 16px;

  background: white;
}

.ordenes-empty-icon {
  width: 64px;
  height: 64px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 18px;

  background: #f0f3f7;
}

.ordenes-empty-icon .v-icon {
  font-size: 30px;
  color: var(--tpv-light);
}

.ordenes-empty-title {
  margin-top: 15px;

  font-size: 16px;
  font-weight: 700;

  color: var(--tpv-text);
}

.ordenes-empty-text {
  max-width: 320px;

  margin-top: 5px;

  font-size: 12px;
  line-height: 18px;

  color: var(--tpv-muted);
}

/* ============================================================
   TABLET
   ============================================================ */

@media (max-width: 1200px) {
  .ordenes-grid {
    grid-template-columns: repeat(
      4,
      minmax(0, 1fr)
    );
  }

  .orden-card {
    min-height: 280px;
  }
}

/* ============================================================
   TABLET PEQUEÑA
   ============================================================ */

@media (max-width: 850px) {
  .ordenes-content {
    padding: 15px;
  }

  .ordenes-grid {
    grid-template-columns: repeat(
      3,
      minmax(0, 1fr)
    );

    gap: 12px;
  }

  .orden-card {
    min-height: 270px;
  }
}

/* ============================================================
   MÓVIL
   ============================================================ */

@media (max-width: 600px) {
  .ordenes-dialog {
    border-radius: 14px !important;
  }

  .ordenes-header {
    height: 60px;
    min-height: 60px;

    padding: 0 12px;
  }

  .ordenes-header-icon {
    display: none;
  }

  .ordenes-title {
    font-size: 15px;
  }

  .ordenes-subtitle {
    font-size: 10px;
  }

  .ordenes-counter {
    display: none;
  }

  .ordenes-content {
    padding: 12px;

    max-height: calc(100vh - 60px);
  }

  .ordenes-grid {
    grid-template-columns: repeat(
      2,
      minmax(0, 1fr)
    );

    gap: 10px;
  }

  .orden-card {
    min-height: 265px;

    border-radius: 13px !important;
  }

  .orden-card-header {
    padding: 12px 12px 7px;
  }

  .orden-card-content {
    padding: 4px 12px 10px;
  }

  .orden-card-footer {
    min-height: 36px;

    padding: 0 12px;
  }

  .orden-number {
    font-size: 19px;
  }
}

/* ============================================================
   MÓVIL PEQUEÑO
   ============================================================ */

@media (max-width: 430px) {
  .ordenes-grid {
    grid-template-columns: 1fr;
  }

  .orden-card {
    min-height: 230px;
  }

  .orden-card-content {
    padding-bottom: 8px;
  }

  .orden-info-row {
    font-size: 10px;
  }
}
</style>